import { apiFetch } from '@/lib/api';

export interface GlossaryLangCount { code: string; name: string; count: number }
export interface GlossaryStats {
  total_terms: number;
  preserved: number;
  translatable: number;
  total_translations: number;
  by_language: GlossaryLangCount[];
}

export function getGlossaryStats(): Promise<GlossaryStats> {
  return apiFetch<GlossaryStats>('/glossary/stats');
}
